import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import GradeMap from "./routes/GradeMap";
import DepartmentMap from "./routes/DepartmentMap";
import CourseMap from "./routes/CourseMap";
import MapsFullScreenPreview from "./routes/MapsFullScreenPreview";
import CurriculumOverviewMap from "./routes/CurriculumOverviewMap";

export default store => ({
  path: ":website_id",
  component: withAsyncRouteLoading(() =>
    Promise.all([
      import(/* webpackChunkName: "curriculum-website" */ "./components"),
    ]).then(([importedModule0]) => {
      const component = importedModule0.default;

      return component;
    })
  ),
  childRoutes: [
    GradeMap(store),
    DepartmentMap(store),
    CourseMap(store),
    MapsFullScreenPreview(store),
    CurriculumOverviewMap(store),
  ],
});
